import * as React from "react";
export function SvgCertifiedIconDefault(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={13} height={13} {...props}>
      <g fillRule="nonzero" fill="none">
        <path
          d="M12.652 5.493c.783-1.002.173-2.476-1.09-2.631a1.637 1.637 0 0 1-1.424-1.424A1.635 1.635 0 0 0 7.507.348a1.63 1.63 0 0 1-2.013 0 1.636 1.636 0 0 0-2.631 1.09 1.637 1.637 0 0 1-1.424 1.424C.176 3.017-.434 4.491.349 5.493a1.637 1.637 0 0 1 0 2.014c-.783 1.002-.173 2.475 1.09 2.631a1.635 1.635 0 0 1 1.424 1.424 1.636 1.636 0 0 0 2.63 1.089 1.633 1.633 0 0 1 2.014 0 1.635 1.635 0 0 0 2.631-1.089 1.635 1.635 0 0 1 1.424-1.424c1.263-.156 1.873-1.629 1.09-2.631a1.637 1.637 0 0 1 0-2.014"
          fill="#00A370"
        />
        <path
          d="M8.347 3.196l.875.485L6.068 9.38a.5.5 0 0 1-.596.232l-.083-.037a.503.503 0 0 1-.077-.052.433.433 0 0 1-.094-.072l-2.48-2.456.708-.707 2.06 2.041 2.841-5.133z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}
